import { PortDTO } from '@interfaces/KT/Port.interface';

export class EventDictionary {
  dictionary: Record<
    number,
    {
      type: 0 | 1;
      hour: string;
      harbour: PortDTO;
    }[]
  > = {};

  public addEvent(day: number, type: 0 | 1, hour: string, harbour: PortDTO) {
    let eventsList = this.dictionary[day];
    if (eventsList == null) {
      eventsList = [];
      this.dictionary[day] = eventsList;
    }

    eventsList.push({ type, hour, harbour });
  }

  public getEvents(day) {
    const events = this.dictionary[day] || [];

    return events.sort((a, b) => {
      return parseInt(a.hour) - parseInt(b.hour);
    });
  }
}
